import { type IWidgetParsedProps } from '@framework/engine/schema/widgets/repository/inputs/common/util/getWidgetProps.ts';
import { uploadWidgetFilenameField } from '../createUploadWidgetFormSchema.ts';
import { publicDataUploadWidgetName } from '../UploadWidget.type.tsx';

export function useUploadWidgetFieldName(params: {
  publicUpload: boolean | null | undefined;
  options: IWidgetParsedProps;
}) {
  const { publicUpload, options } = params;

  const fieldName = publicUpload
    ? publicDataUploadWidgetName(options.name)
    : options.name;

  const filenameFieldName = uploadWidgetFilenameField(fieldName);

  return { fieldName, filenameFieldName };
}
